import { equals } from 'ramda';

import LandingPage from '../../pages/Landing/Loadable';

import { mainWorkflow } from './main';
import { errorWorkflow } from './extraWorkflows';
import states from '../states';
import events from '../events';
import ducks from '../../ducks/ducks';
import { APPROVED, AUTH_ERROR, AUTHENTICATED, CLAIM_LOADED, MISSION_LOADED, REQUEST_ERROR } from '../../ducks/coreApi';
import { getErrorCode } from '../../selectors/error';
import { getPreviousClaimId, getPreviousMissionId, getIsClaimNotDisplayed, getIsNonEditableClaim } from '../../selectors/coreApi';

import { getActionsFromDucks } from '../utils';
import { isRequestError403, isRequestError404 } from '../../utils/error';
import { isMissionEnded, isMissionInProgress } from '../../utils/coreApi';
import { ERROR_CODES } from '../../enums';

const actions = getActionsFromDucks(ducks);

const computeInitialState = state => {
  if (getPreviousClaimId(state) && getPreviousMissionId(state)) {
    return states.LANDING_SESSION;
  }
  return states.VOICE_EXIT;
};

const config = {
  key: 'drsa',
  computeInitialState,
  states: {
    ...mainWorkflow,
    [states.LANDING_SESSION]: {
      component: LandingPage,
      on: {
        [events.START]: {
          target: states.LANDING_SESSION,
          actions: [actions.coreApi.authenticate],
        },
        [APPROVED]: {
          target: states.LANDING_SESSION,
          actions: [actions.coreApi.loadClaimById],
        },
        [AUTHENTICATED]: {
          target: states.LANDING_SESSION,
          actions: [actions.coreApi.loadClaimById],
        },
        [CLAIM_LOADED]: [
          {
            cond: state => getIsNonEditableClaim(state),
            target: states.PREVIOUS_CLAIM_HANDLING,
          },
          {
            cond: state => getIsClaimNotDisplayed(state),
            target: states.VOICE_EXIT,
          },
          {
            target: states.LANDING_SESSION,
            actions: [actions.coreApi.searchMissionByPreviousId],
          },
        ],
        [MISSION_LOADED]: [
          {
            target: states.MISSION_MONITORING,
            cond: isMissionInProgress,
            actions: [actions.coreApi.startMissionMonitoring],
          },
          {
            target: states.END_MISSION,
            cond: isMissionEnded,
          },
        ],
        [REQUEST_ERROR]: [
          {
            cond: state =>
              (isRequestError403(state) && equals(getErrorCode(state), ERROR_CODES.RESOURCE_ACCESS_ISSUE)) ||
              (isRequestError404(state) && equals(getErrorCode(state), ERROR_CODES.CLAIM_NOT_FOUND)),
            target: states.VOICE_EXIT,
          },
          ...errorWorkflow(AUTH_ERROR),
        ],
      },
    },
  },
};

export default config;
